import { z } from 'zod/v4';

export const LSLocalitySchema = z.object({
    localityId: z.string().toUpperCase(),
    localityName: z.string(),
    lat: z.number(),
    lng: z.number(),
    radiusKms: z.number().int()
});

export type LSLocality = z.infer<typeof LSLocalitySchema>;